import React, { PureComponent } from 'react';
import { Stepper, Steps, Step, Progress, Stage } from 'components/Stepper';
import FieldsMappingTabs from 'containers/settings/deprecatedIntegrationsManagement/components/FieldsMappingTabs';
import UsersMapping from 'containers/settings/deprecatedIntegrationsManagement/components/UsersMapping';
import SyncSummary from 'containers/settings/deprecatedIntegrationsManagement/components/SyncSummary';
import { ButtonPrimary } from 'components/buttons';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { ErrorAlert, ProgressAlert } from 'components/alerts';
import './style.scss';

class Settings extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    renderProgress(items) {
        let progress = [];
        items.forEach((element, index) => {
            progress.push(<Stage key={index} num={index + 1} literal={element} />);
        });
        return progress;
    }

    renderUsers() {
        const {
            fmUsers,
            extUsers,
            usersConfig,
            onAddUser,
            onDeleteUser,
            stepperAlertErrors,
            literals,
        } = this.props;
        let usersContent = {
            fmUsers,
            extUsers,
            usersConfig,
            onAddUser,
            onDeleteUser,
            literals,
            stepperAlertErrors: (stepperAlertErrors && stepperAlertErrors['users']) || {},
        };
        return <Step num={1} content={<UsersMapping {...usersContent} />} />;
    }

    renderFields() {
        const {
            fields,
            selectFields,
            fieldsConfig,
            onFieldsSelChange,
            onFieldsDefaultChange,
            getFmValuelist,
            fmValueList,
            literals,
            stepperAlertErrors,
        } = this.props;
        let fieldsContent = {
            fields,
            selectFields,
            fieldsConfig,
            onFieldsSelChange,
            onFieldsDefaultChange,
            getFmValuelist,
            fmValueList,
            literals,
            stepperAlertErrors: (stepperAlertErrors && stepperAlertErrors['fields']) || {},
        };
        return <Step num={2} content={<FieldsMappingTabs {...fieldsContent} />} />;
    }

    renderSync() {
        const { fieldsConfig, usersConfig, fieldsMatched, cronstatus } = this.props;
        if (cronstatus !== 'no cron') return null;
        let syncContent = {
            fieldsConfig,
            usersMatched: usersConfig.length,
            fieldsMatched,
        };
        return <Step num={3} content={<SyncSummary {...syncContent} />} />;
    }

    render() {
        const {
            dataReady,
            dataProgress,
            error,
            errorType,
            stepperStage,
            stepperSetSteps,
            stepperGoToStep,
            onStepperClickPrev,
            onStepperClickNext,
            onStepperClickCancel,
            onClickRetry,
            cronstatus,
            literals,
        } = this.props;
        let steps, prevBtnTxt, nextBtnTxt;
        if (cronstatus === 'no cron') {
            steps = [
                literals['label_integration_match_users'] || 'label_integration_match_users',
                literals['label_integration_match_fields'] || 'label_integration_match_fields',
                literals['label_integration_sync'] || 'label_integration_sync',
            ];
            prevBtnTxt = [
                null,
                literals['action_integration_back_to_users_matching'] ||
                    'action_integration_back_to_users_matching',
                literals['action_integration_back_to_fields_matching'] ||
                    'action_integration_back_to_fields_matching',
            ];
            nextBtnTxt = [
                literals['action_save_matches'] || 'action_save_matches',
                literals['action_save_matches'] || 'action_save_matches',
                literals['action_integration_sync_now'] || 'action_integration_sync_now',
            ];
        } else {
            steps = [
                literals['label_integration_match_users'] || 'label_integration_match_users',
                literals['label_integration_match_fields'] || 'label_integration_match_fields',
            ];
            prevBtnTxt = [
                null,
                literals['action_integration_back_to_users_matching'] ||
                    'action_integration_back_to_users_matching',
            ];
            nextBtnTxt = [
                literals['action_save_matches'] || 'action_save_matches',
                literals['action_save_matches'] || 'action_save_matches',
            ];
        }
        if (
            error &&
            (errorType === 'GET_INTEGRATIONS_FM_FIELDS' ||
                errorType === 'GET_INTEGRATIONS_FM_USERS' ||
                errorType === 'GET_INTEGRATIONS_EXT_FIELDS' ||
                errorType === 'GET_INTEGRATIONS_EXT_USERS' ||
                errorType === 'GET_INTEGRATIONS_EXT_FIELDS_CONFIG' ||
                errorType === 'GET_INTEGRATIONS_EXT_USERS_CONFIG')
        ) {
            return (
                <div className="integration-settings">
                    <ErrorAlert
                        title={
                            <Literal
                                literal={
                                    literals['label_error_integration_title_getting_data'] ||
                                    'label_error_integration_title_getting_data'
                                }
                            />
                        }
                        text={
                            <Literal
                                literal={
                                    literals['label_error_integration_descript_getting_data'] ||
                                    'label_error_integration_descript_getting_data'
                                }
                            />
                        }
                        shrink={true}
                    />
                    <ButtonPrimary classes={['retry-btn']} onClick={onClickRetry}>
                        <Literal literal={'action_download_retry'} />
                    </ButtonPrimary>
                </div>
            );
        } else if (!dataReady) {
            return (
                <div className="integration-settings">
                    <ProgressAlert
                        title={
                            <Literal
                                literal={
                                    literals['label_integration_getting_data'] ||
                                    'label_integration_getting_data'
                                }
                            />
                        }
                        text={
                            <Literal
                                literal={
                                    literals['label_integration_getting_data_description'] ||
                                    'label_integration_getting_data_description'
                                }
                            />
                        }
                        progress={dataProgress}
                        shrink={true}
                    />
                </div>
            );
        }
        return (
            <div className="integration-settings">
                <Stepper
                    stage={stepperStage}
                    prevBtnTxt={prevBtnTxt}
                    nextBtnTxt={nextBtnTxt}
                    cancelBtnTxt={'action_cancel'}
                    setSteps={stepperSetSteps}
                    goToStep={stepperGoToStep}
                    onClickPrev={onStepperClickPrev}
                    onClickNext={onStepperClickNext}
                    onClickCancel={onStepperClickCancel}
                >
                    <Progress>{this.renderProgress(steps)}</Progress>
                    <Steps>
                        {this.renderUsers()}
                        {this.renderFields()}
                        {this.renderSync()}
                    </Steps>
                </Stepper>
            </div>
        );
    }
}

export default Settings;
